import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import linkGreenIcon from 'assets/images/icons/link-green.svg';
import infoCircleGreyIcon from 'assets/images/icons/info-circle.svg';
import InfoTooltip from 'components/common-components/InfoTooltip';
import { CallAPI } from 'actions/General';
import { FONT_FAMILY_MAP } from '../utils';

const ImageChartComponent = ({ widget }) => {
  const { basicProps, advancedProps } = widget;
  const captionFontFamily = FONT_FAMILY_MAP[advancedProps.captionFontWeight] || '';
  const [url, setUrl] = useState(null);

  const getImageUrl = async () => {
    const mediaPayload = [
      {
        folderType: 'internal-dashboard',
        mediaId: basicProps.widgetImage.mediaId,
        mediaType: basicProps.widgetImage.mediaType,
        imageName: basicProps.widgetImage.imageName,
        dashboardId: basicProps.widgetImage.dashboardId,
        dashboardPageId: basicProps.widgetImage.dashboardPageId,
      },
    ];

    const result = await CallAPI('GET_GENERIC_BULK_DOWNLOAD_MEDIA_REDIRECT_URL', {
      medias: mediaPayload,
    });

    if (result.status) {
      setUrl(result.data[0]?.url ?? null);
    }
  };

  useEffect(() => {
    if (widget) getImageUrl();
  }, []);

  return (
    <div className='d-flex align-items-center position-relative'>
      <div className='image-fit-and-center'>{url && <img src={url} />}</div>
      <div className='position-absolute left-0 bottom-0 d-flex align-items-center align-self-start p-3 gap-2'>
        {basicProps.caption && (
          <span
            style={{
              fontSize: advancedProps.captionFontSize,
              fontFamily: captionFontFamily,
            }}
          >
            {basicProps.caption}
          </span>
        )}
        {advancedProps.tooltip && (
          <InfoTooltip
            text={advancedProps.tooltip}
            triggerElement={<img src={infoCircleGreyIcon} />}
          />
        )}
        {advancedProps.linkedPageId && (
          <img
            className='cursor-pointer'
            src={linkGreenIcon}
            onClick={() => {
              window.open(
                `/dashboards/navigate/${advancedProps.linkedDashboardId}/${advancedProps.linkedPageId}`,
                '_blank',
              );
            }}
          />
        )}
      </div>
    </div>
  );
};

ImageChartComponent.propTypes = {
  widget: PropTypes.object.isRequired,
};

export default ImageChartComponent;
